<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-input v-model="formDatas.ahaUserName" style="width: 120px;" size="mini" placeholder="姓名"
                        clearable></el-input>
                    <el-input v-model="formDatas.ahaUserDepartment" style="width: 120px;" size="mini" placeholder="部门"
                        clearable></el-input>
                    <el-select size="mini" v-model="formDatas.ahaStatus" clearable @change="partserch"
                        placeholder="请选择状态" style="width: 130px">
                        <el-option label="申请中" :value="1" key="1"></el-option>
                        <el-option label="同意" :value="2" key="2"></el-option>
                        <el-option label="拒绝" :value="3" key="3"></el-option>
                        <el-option label="已撤销" :value="4" key="4"></el-option>
                        <el-option label="已退房" :value="5" key="5"></el-option>
                    </el-select>
                    <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                    <!-- <el-button type="primary" size="mini" style="margin-right: 10px;"
                        @click="bulkImport = true">批量导入</el-button> -->
                    <!-- <el-button type="warning" size="mini" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                    <!-- <el-button type="danger" size="mini" style="margin-left: 10px" @click="BulkDelete">批量删除</el-button> -->
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <!-- <el-button type="success" size="mini" style="margin-right: 20px" @click="BoxOpen">新增入住申请</el-button> -->

                    <!-- <el-button type="warning" size="mini" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                        row-key-field-name="ahaId" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                        :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 新增 -->
            <el-drawer :wrapperClosable="false" :title="edit == true ? '编辑预计退房时间' : '新增入住申请'"
                :before-close="handleClose" :visible.sync="dialog" direction="rtl" custom-class="demo-drawer"
                ref="drawer">
                <div class="demo-drawer__content" style="height: 90%;">
                    <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
                        <div
                            style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">

                            <el-form-item label="预计退房时间" prop="ahaUserDateCheckOut">
                                <el-date-picker v-model="form.ahaUserDateCheckOut" type="datetime"
                                    value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期" style="width: 100%">
                                </el-date-picker>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="demo-drawer__footer" style="margin-top: 10px;">
                    <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">
                        确 定</el-button>
                </div>
            </el-drawer>
            <el-dialog title="状态" :visible.sync="dialogStatus" width="70%" top="8vh">
                <div style=" width: 94%; height: 90%;margin:1% auto;background-color: white;overflow-y: scroll;">
                    <div style="width: 100%; height: 100%; padding: 5%">
                        <el-form ref="formCheck" :model="formCheck" label-position="top" label-width="150px"
                            @submit.native.prevent>
                            <el-form-item label="是否同意" prop="ahaStatus">
                                <el-radio-group v-model="formCheck.ahaStatus">
                                    <el-radio label="2">同意</el-radio>
                                    <el-radio label="3">拒绝</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="宿舍房间" prop="ahbId" v-if="formCheck.ahaStatus == 2">
                                <el-select v-model="formCheck.ahbId" filterable placeholder="请选择">
                                    <el-option v-for="item in statusAll || []" :label="item.ahbName" :value="item.ahbId"
                                        :key="item.ahbId"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="审核备注" prop="checkDes">
                                <el-input v-model="formCheck.checkDes" style="width: 100%;" placeholder="请输入"
                                    type="textarea"></el-input>
                            </el-form-item>
                        </el-form>
                        <span slot="footer" class="dialog-footer">
                            <el-button @click="closeStatus">取 消</el-button>
                            <el-button type="primary" @click="sureStatus">确 定</el-button>
                        </span>
                    </div>
                </div>
            </el-dialog>
            <el-dialog title="退房申请" :visible.sync="isCheckOut" width="70%" top="8vh">
                <div style=" width: 94%; height: 90%;margin:1% auto;background-color: white;overflow-y: scroll;">
                    <div style="width: 100%; height: 100%; padding: 5%">
                        <el-form ref="formRefCheck" :model="form" label-position="top" label-width="150px"
                            @submit.native.prevent>
                            <el-form-item label="1. 状态" prop="ahcoStatus">
                                <el-radio-group v-model="form.ahcoStatus">
                                    <el-radio label="2">按要求退房</el-radio>
                                    <el-radio label="3">未按要求退房</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="2. 实际退房时间" prop="ahcoDateCheckOut">
                                <el-date-picker v-model="form.ahcoDateCheckOut" type="datetime"
                                    value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择时间" style="width: 100%;">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="3. 用过床单被罩枕套" prop="ahcoTwo">
                                <el-select v-model="form.ahcoTwo" placeholder="请选择" style="width: 100%;">
                                    <el-option label="已机洗并晾晒" value="已机洗并晾晒"></el-option>
                                    <el-option label="未清洗已叠好放床尾" value="未清洗已叠好放床尾"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="4.  用过床单被罩枕套拍照" prop="ahcoTwoSign">
                                <my-upload ref="Imgupload" @fileChange="fileChange" :filearr="fileList" :limit="10"
                                    @removeAfter="removeAfter" style="margin: 10px 5px 5px;">
                                </my-upload>
                            </el-form-item>
                            <el-form-item label="5. 钥匙归还" prop="ahcoThree">
                                <el-select v-model="form.ahcoThree" placeholder="请选择" style="width: 100%;">
                                    <el-option label="密码锁无需" value="密码锁无需"></el-option>
                                    <el-option label="已归还" value="已归还"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="6.  钥匙归还拍照" prop="ahcoThreeSign">
                                <my-upload ref="Imgupload2" @fileChange="fileChange2" :filearr="fileList2" :limit="10"
                                    @removeAfter="removeAfter2" style="margin: 10px 5px 5px;">
                                </my-upload>
                            </el-form-item>
                            <el-form-item label="7. 宿舍内原有生活备用品是否需要补充" prop="ahcoFour">
                                <el-select v-model="form.ahcoFour" placeholder="请选择" style="width: 100%;">
                                    <el-option label="是" value="是"></el-option>
                                    <el-option label="否" value="否"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="8. 补充描述" prop="ahcoFourDes">
                                <el-input v-model="form.ahcoFourDes" style="width: 100%;" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item label="9. 个人物品是否都清理干净，房间内无垃圾？" prop="ahcoFive">
                                <el-select v-model="form.ahcoFive" placeholder="请选择" style="width: 100%;">
                                    <el-option label="是" value="是"></el-option>
                                    <el-option label="否" value="否"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="10.  房间拍照" prop="ahcoFiveSign">
                                <my-upload ref="Imgupload3" @fileChange="fileChange3" :filearr="fileList3" :limit="10"
                                    @removeAfter="removeAfter3" style="margin: 10px 5px 5px;">
                                </my-upload>
                            </el-form-item>
                            <el-form-item label="11. 门锁/空调/窗户 是否已检查关好" prop="ahcoSix">
                                <el-select v-model="form.ahcoSix" placeholder="请选择" style="width: 100%;">
                                    <el-option label="是" value="是"></el-option>
                                    <el-option label="否" value="否"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="12.  门锁/空调/窗户 拍照" prop="ahcoSixSign">
                                <my-upload ref="Imgupload4" @fileChange="fileChange4" :filearr="fileList4" :limit="10"
                                    @removeAfter="removeAfter4" style="margin: 10px 5px 5px;">
                                </my-upload>
                            </el-form-item>
                            <el-form-item label="13. 审核备注" prop="checkDes">
                                <el-input v-model="form.checkDes" style="width: 100%;" placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-form>
                        <span slot="footer" class="dialog-footer">
                            <el-button @click="closeCheckOut">取 消</el-button>
                            <el-button type="primary" @click="sureCheckOut">确 定</el-button>
                        </span>
                    </div>
                </div>
            </el-dialog>

            <!-- 批量导入 -->
            <el-dialog title="批量导入" :visible.sync="bulkImport" width="70%" :before-close="bulkImportClose"
                style="margin-left: 200px;">
                <div style="margin: 0 10px 10px;display: flex;">
                    <el-upload class="upload-demo" action="#" accept=".xlsx,.xls" :on-change="updatabulk"
                        :auto-upload="false" ref="bulk" multiple>
                        <el-button size=" medium" type="danger">点击上传</el-button>

                    </el-upload>
                    <div>
                        <el-button type="primary"
                            @click="downloadFile('https://trainapp.aojuai.com/assets/excel/fireequipment.xlsx', '入住申请模板')"
                            style="margin-left: 20%;height: 40px;">下载模板</el-button>
                    </div>
                </div>
                <div>
                    <ve-table :columns="columnsImport" :table-data="bulkData" :max-height="500" :border-x="true"
                        :border-y="true" :scrollWidth="10" row-key-field-name="dataIndex"
                        :cell-style-option="cellStyleOption" style="width: 100%" />
                    <div v-show="bulkData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div style="margin: 10px;font-size: 18px;" v-if="bulkData.length != 0">
                    <span style="color: #0080FF;">一共{{ importData.numAll }}条;</span>
                    <span style="color: #0E9A00;margin-left: 5px;">成功{{ importData.numSuccess }}条;</span>
                    <span style="color: red;margin-left: 5px;">失败{{ importData.numFail }}条</span>
                    <span style="color: #E6A23C;margin-left: 5px;">信息不完整{{ importData.numUnWhole }}条</span>
                </div>
                <div slot="footer" class="dialog-footer" style="width:80%; margin: 10px auto;">
                    <!-- <el-button @click="bulkImportClose">取 消</el-button> -->
                    <el-button type="success" @click="bulkImportClick">确定导入</el-button>
                </div>
            </el-dialog>
            <!-- 房间详情 -->
            <el-dialog title="房间详情" :visible.sync="isRoom" width="70%" style="margin-left: 200px;">
                <div>
                    <ve-table :columns="columnsRoom" :table-data="RoomDetail" :max-height="500" :border-x="true"
                        :border-y="true" :scrollWidth="10" row-key-field-name="dataIndex"
                        :cell-style-option="cellStyleOption" style="width: 100%" />
                    <div v-show="RoomDetail.length == 0" class="empty-data">暂无数据</div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import qs from 'qs';
import axios from 'axios';
import config from '../../api/env.js';
import {
    getAjHostelBaseList, updateAjHostelApplyCheck, uploadImportAjAssetsFireEquipment, addAjHostelCheckOutSystem,
    getAjHostelApplyList, addAjAssetsFireEquipment, updateAjHostelApplyDateCheckOut, deleteAjAssetsFireEquipment, uploadAjAssetsFireEquipment
} from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            isCheckOut: false,
            fileList: [],
            fileList2: [],
            fileList3: [],
            fileList4: [],

            isRoom: false,
            RoomDetail: [],
            formCheck: {},
            theRow: {},
            form2: {},
            diaAddReturn: false,
            diaDetail: false,
            tableDataDetail: [],
            statusAll: [
            ],
            dialogStatusValue: '',
            dialogStatus: false,
            key: 'ahaId',
            dialog: false,
            edit: false,
            form: {
                ahcoTwoSign:[],
                ahcoThreeSign:[],
                ahcoFiveSign:[],
                ahcoSixSign:[],
            },
            rules: {},
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,
            columnsImport: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "aafeNums",
                    key: "aafeNums",
                    title: "灭火器编号",
                    align: "center",
                },
                {
                    field: "equipmentName",
                    key: "equipmentName",
                    title: "设备名称",
                    align: "center",
                },
                {
                    field: "storageLocation",
                    key: "storageLocation",
                    title: "存放位置",
                    align: "center",
                },
                {
                    field: "purchaseDate",
                    key: "purchaseDate",
                    title: "购买日期",
                    align: "center",
                },
                {
                    field: "netWeight",
                    key: "netWeight",
                    title: "净含量",
                    align: "center",
                    edit: true,
                },
                {
                    field: "modelC",
                    key: "modelC",
                    title: "3C规格型号",
                    align: "center",
                    edit: true,
                },
                {
                    field: "cccCertificateNumber",
                    key: "cccCertificateNumber",
                    title: "ccc证书编号",
                    align: "center",
                },
                {
                    field: "manufacturer",
                    key: "manufacturer",
                    title: "制造厂家",
                    align: "center",
                },
                {
                    field: "hasLabel",
                    key: "hasLabel",
                    title: "是否有标签",
                    align: "center",
                },
                {
                    field: "hasExpired",
                    key: "hasExpired",
                    title: "是否过期",
                    align: "center",
                },
                {
                    field: "personInCharge",
                    key: "personInCharge",
                    title: "负责人",
                    align: "center",
                },
                {
                    field: "expectedExpiryDate",
                    key: "expectedExpiryDate",
                    title: "预计到期时间",
                    align: "center",
                },
                {
                    field: "remarks",
                    key: "remarks",
                    title: "备注",
                    align: "center",
                },
            ],
            columnsRoom: [{
                field: "ahbName",
                key: "ahbName",
                title: "房间名称",
                align: "center",
            },
            {
                field: "ahbAddress",
                key: "ahbAddress",
                title: "地址",
                align: "center",
            },
            {
                field: "ahbStructure",
                key: "ahbStructure",
                title: "居室布局",
                align: "center",
            },
            {
                field: "ahbPw",
                key: "ahbPw",
                title: "门锁密码",
                align: "center",
            },
            {
                field: "ahbWifiAccount",
                key: "ahbWifiAccount",
                title: "wifi账号",
                align: "center",
                edit: true,
            },
            {
                field: "ahbWifiPw",
                key: "ahbWifiPw",
                title: "wifi密码",
                align: "center",
                edit: true,
            },
            {
                field: "ahbDailyNecessities",
                key: "ahbDailyNecessities",
                title: "现存生活用品",
                align: "center",
            },
            {
                field: "ahbRoomsNum",
                key: "ahbRoomsNum",
                title: "房间数",
                align: "center",
            },
            {
                field: "ahbReminds",
                key: "ahbReminds",
                title: "提醒",
                align: "center",
            },],
            columns: [
                {
                    field: "",
                    key: "checkbox",
                    // type=checkbox
                    type: "checkbox",

                    title: "",
                    width: 50,
                    align: "center",
                },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "ahaUserName",
                    key: "ahaUserName",
                    title: "申请人",
                    align: "center",
                    width: 100,
                },
                {
                    field: "ahaUserDepartment",
                    key: "ahaUserDepartment",
                    title: "申请人部门",
                    align: "center",
                    width: 100,
                },
                {
                    field: "ahaUserDateCheckIn",
                    key: "ahaUserDateCheckIn",
                    title: "入住时间",
                    align: "center",
                    width: 180,
                },
                {
                    field: "ahaUserDateCheckOut",
                    key: "ahaUserDateCheckOut",
                    title: "预计退房时间",
                    align: "center",
                    width: 180,
                },
                {
                    field: "ahaUserPet",
                    key: "ahaUserPet",
                    title: "是否对猫狗过敏",
                    align: "center",
                    width: 100,
                },
                {
                    field: "ahaSign",
                    key: "ahaSign",
                    title: "签名图片",
                    align: "center",
                    width: 120,
                    // fixed:'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.ahaSign ? <el-image ref="scrImg" id="scrimg" src={row.ahaSign} alt="" fit="fill" style="width: 50px;height: 50px;"
                                        previewSrcList={[row.ahaSign]}></el-image> : <span></span>
                                }
                            </span>
                        );
                    },

                },
                {
                    field: "ahbName",
                    key: "ahbName",
                    title: "入住房间",
                    align: "center",
                    width: 180,
                    // fixed:'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.ahbName ? <el-button
                                        size="mini" type="text" style="color:green" on-click={() => this.handleRoomDetail(row)} > {row.ahbName} </el-button> : <span></span>
                                }
                            </span>
                        );
                    },

                },
                {
                    field: "checkDes",
                    key: "checkDes",
                    title: "审核备注",
                    align: "center",
                    width: 180,
                },
                {
                    field: "ahaStatus",
                    key: "ahaStatus",
                    title: "状态",
                    width: 150,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.ahaStatus == 1 ? <el-tag size="mini">申请中</el-tag> : row.ahaStatus == 2 ? <el-tag type="success" size="mini">入住中</el-tag>
                                        : row.ahaStatus == 3 ? <el-tag type="danger" size="mini">拒绝</el-tag> : row.ahaStatus == 4 ? <el-tag type="danger" size="mini">已撤销</el-tag>
                                            : <el-tag type="success" size="mini">已退房</el-tag>
                                }
                                {
                                    row.ahaStatus == 1 ?
                                        <el-button
                                            size="mini" type="text" style="color:green" on-click={() => this.handleCheck(row)} > 审核 </el-button> : <span></span>
                                }

                            </span>
                        );
                    },
                },
                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 200,
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.ahaStatus == 2 ? <el-button
                                        size="mini"
                                        type="text"
                                        on-click={() => this.handleEdit(row)}
                                    >
                                        修改预计退房时间
                                    </el-button> : ''
                                }
                                {
                                    row.ahaStatus == 2 ? <el-button
                                        size="mini"
                                        type="text"
                                        style="color:red"
                                        on-click={() => this.handleCheckOut(row)}
                                    >
                                        系统退房
                                    </el-button> : ''
                                }

                            </span>
                        );
                    },
                },

            ], //表格的列
            tableData: [],
            post: null,
            formDatas: {
                dmDelete: 1,
                currentPage: 1,
                pageSize: 10,
            },
            bulkImport: false,
            bulkData: [],
            bulkDataCopy: [],
            sitId: '',
            importData: {},

        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        this.getList();
    },
    mounted() { },
    methods: {
        closeCheckOut() {
            this.isCheckOut = false;
            this.$refs['formRefCheck'].resetFields();
            this.form = {}
            this.fileList = []
            this.fileList2 = []
            this.fileList3 = []
            this.fileList4 = []
        },
        sureCheckOut() {
            var that = this;
            this.$confirm("是否确定要退房吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var newForm = JSON.parse(JSON.stringify(that.form))
                    newForm.ahcoTwoSign = newForm.ahcoTwoSign && newForm.ahcoTwoSign.length > 0 ? JSON.stringify(newForm.ahcoTwoSign) : '';
                    newForm.ahcoThreeSign = newForm.ahcoThreeSign && newForm.ahcoThreeSign.length > 0 ? JSON.stringify(newForm.ahcoThreeSign) : '';
                    newForm.ahcoSixSign = newForm.ahcoSixSign && newForm.ahcoSixSign.length > 0 ? JSON.stringify(newForm.ahcoSixSign) : '';
                    newForm.ahcoFiveSign = newForm.ahcoFiveSign && newForm.ahcoFiveSign.length > 0 ? JSON.stringify(newForm.ahcoFiveSign) : '';
                    addAjHostelCheckOutSystem(newForm).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "退房成功!",
                            });
                            this.partserch();
                            this.closeCheckOut();
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleCheckOut(row) {
            this.form.ahaId = row.ahaId;
            this.isCheckOut = true;
        },
        removeAfter(file) {
            console.log(file,this.fileList);
            const url = this.form.ahcoTwoSign.findIndex(item => item === file)
            this.form.ahcoTwoSign.splice(url, 1)
        },
        // 上传图片
        fileChange(file) {
            console.log(this.form.ahcoTwoSign, file);
            if (this.form.ahcoTwoSign && this.form.ahcoTwoSign.length > 0) {
                console.log(this.form.ahcoTwoSign, file);
                this.form.ahcoTwoSign.push(...file)
                file.forEach((item, index) => {
                    const s = {
                        url: item,
                        name: item
                    }
                    this.fileList.push(s)
                })
            } else {
                this.$set(this.form, 'ahcoTwoSign', file)
                file.forEach((item, index) => {
                    const s = {
                        url: item,
                        name: item
                    }
                    this.fileList.push(s)
                })
            }
            this.$message({
                type: "success",
                message: "上传成功!",
            });

        },
        removeAfter2(file) {
            const url = this.form.ahcoThreeSign.findIndex(item => item === file)
            this.form.ahcoThreeSign.splice(url, 1)
        },
        // 上传图片
        fileChange2(file) {
            console.log(this.form.ahcoThreeSign, file);
            if (this.form.ahcoThreeSign && this.form.ahcoThreeSign.length > 0) {
                console.log(this.form.ahcoThreeSign, file);
                this.form.ahcoThreeSign.push(...file)
                file.forEach((item, index) => {
                    const s = {
                        url: item,
                        name: item
                    }
                    this.fileList2.push(s)
                })
            } else {
                this.$set(this.form, 'ahcoThreeSign', file)
                file.forEach((item, index) => {
                    const s = {
                        url: item,
                        name: item
                    }
                    this.fileList2.push(s)
                })
            }
            this.$message({
                type: "success",
                message: "上传成功!",
            });

        },

        removeAfter3(file) {
            const url = this.form.ahcoFiveSign.findIndex(item => item === file)
            this.form.ahcoFiveSign.splice(url, 1)
        },
        // 上传图片
        fileChange3(file) {
            console.log(this.form.ahcoFiveSign, file);
            if (this.form.ahcoFiveSign && this.form.ahcoFiveSign.length > 0) {
                console.log(this.form.ahcoFiveSign, file);
                this.form.ahcoFiveSign.push(...file)
                file.forEach((item, index) => {
                    const s = {
                        url: item,
                        name: item
                    }
                    this.fileList3.push(s)
                })
            } else {
                file.forEach((item, index) => {
                    const s = {
                        url: item,
                        name: item
                    }
                    this.fileList3.push(s)
                })
                this.$set(this.form, 'ahcoFiveSign', file)
            }
            this.$message({
                type: "success",
                message: "上传成功!",
            });

        },
        removeAfter4(file) {
            const url = this.form.ahcoSixSign.findIndex(item => item === file)
            this.form.ahcoSixSign.splice(url, 1)
        },
        // 上传图片
        fileChange4(file) {
            if (this.form.ahcoSixSign && this.form.ahcoSixSign.length > 0) {
               file.forEach((item, index) => {
                    const s = {
                        url: item,
                        name: item
                    }
                    this.fileList4.push(s)
                })
                this.form.ahcoSixSign.push(...file)
            } else {
                this.$set(this.form, 'ahcoSixSign', file)
                file.forEach((item, index) => {
                    const s = {
                        url: item,
                        name: item
                    }
                    this.fileList4.push(s)
                })
            }
            this.$message({
                type: "success",
                message: "上传成功!",
            });

        },
        handleRoomDetail(row) {
            getAjHostelBaseList({ ahbName: row.ahbName }).then((res) => {
                this.RoomDetail = res.data;
                this.isRoom = true;
            });
        },
        handleCheck(row) {
            getAjHostelBaseList({ pageSize: 0 }).then((res) => {
                this.statusAll = res.data;
                this.formCheck.ahaId = row.ahaId;
                this.dialogStatus = true;
            });
        },
        handleAddReturn(row) {
            this.form2 = {
                ahaId: row.ahaId,
            }
            this.diaAddReturn = true;
        },
        SureBtn2() {
            this.$confirm("是否确定要新增, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    addAjAssetsFireEquipment(this.form2).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "新增成功!",
                            });
                            this.handleClose2()
                            this.getList()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleReturn(row) {
            this.$confirm("是否确定要归还吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateAjAssetsKeyBorrowReturnReturn({ aakbrId: row.aakbrId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "归还成功!",
                            });

                            this.partserch();
                            this.getDetailList();
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        getDetail(row) {
            this.theRow = row;
            getAjAssetsKeyBorrowReturnList({ ahaId: row.ahaId }).then((res) => {
                this.tableDataDetail = res.data;
                this.diaDetail = true;
            });
        },
        getDetailList() {
            getAjAssetsKeyBorrowReturnList({ ahaId: this.theRow.ahaId }).then((res) => {
                this.tableDataDetail = res.data;
                this.diaDetail = true;
            });
        },
        downloadFile(url, name) {
            //下载
            if (!url) {
                return;
            }
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.onload = function () {
                document.body.removeChild(link);
            };
            link.setAttribute("download", name);
            document.body.appendChild(link);
            link.click();
        },
        Out() {
            var s = qs.stringify(this.formDatas);
            this.openLoading()
            var that = this
            axios({
                method: 'post',
                url: config.baseURL + '/aj-assets-key/exportAjAssetsKey',
                data: s,
                // withCredentials: true,
                timeout: 1200000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    'userid': window.localStorage.getItem('userid')
                }
            }).then(function (res) {
                if (res.data) {
                    that.loadings.close()
                    let a = document.createElement('a');
                    //ArrayBuffer 转为 Blob
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel"
                    });
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", '入住申请.xlsx');
                    a.click();
                    that.$message({
                        message: "成功",
                        type: "success"
                    });

                }
            })
        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        bulkImportClick() {
            if (this.sitId == '') {
                this.$message({
                    showClose: true,
                    message: "请导入资料",
                    type: 'danger'
                });
            } else {
                uploadImportAjAssetsFireEquipment({
                    sitId: this.sitId
                }).then(res => {
                    this.getList()
                    this.bulkImport = false;
                    this.bulkData = [];
                    this.bulkDataCopy = [];
                    this.sitId = '';
                    this.$refs['bulk'].clearFiles()
                    this.$message({
                        type: 'success',
                        message: '导入成功!'
                    });
                })
            }

        },
        async updatabulk(file, fileList) {
            console.log(file, fileList);
            let Data = new FormData();
            Data.append('file', file.raw)
            this.openLoading()
            uploadAjAssetsFireEquipment(Data).then(res => {
                console.log("上传成功")
                this.loadings.close()
                this.bulkData = res.data.data.resultList;
                this.bulkDataCopy = res.data.data.resultList;
                this.importData = res.data.data.importData;
                this.sitId = res.data.data.sysImportTem.sitId;

            })
        },
        bulkImportClose(done) {
            this.$confirm('确认关闭？')
                .then(_ => {
                    done();
                    this.bulkData = [];
                    this.bulkDataCopy = [];
                    this.$nextTick(() => {
                        this.getList()
                    })
                    this.$refs.bulk.clearFiles();
                })
                .catch(_ => { });
        },
        handleStatus(row) {
            this.theRow = row;
            this.dialogStatusValue = row.aakStatus;
            this.dialogStatus = true;
        },
        sureStatus() {
            updateAjHostelApplyCheck(this.formCheck).then(res => {
                if (res.data) {
                    this.$message({
                        type: "success",
                        message: "修改成功!",
                    });
                    this.getList();
                    this.closeStatus()
                }
            })
        },
        closeStatus() {
            this.formCheck = {};
            this.dialogStatus = false;
        },
        // 批量删除
        BulkDelete() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0) {
                this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        deleteAjAssetsFireEquipment({ ahaIds: this.selectedRowKeysCollection.toString() }).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "删除成功!",
                                });

                                this.partserch()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }
        },
        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {

                    deleteAjAssetsFireEquipment({ ahaId: row.ahaId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.dialog = true;
            this.edit = true;
            this.$nextTick(() => {
                this.form = data;
            })
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        addAjAssetsFireEquipment(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "新增成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        updateAjHostelApplyDateCheckOut(this.form).then(res => {
                            if (res.data) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
        },
        // 关闭弹框
        handleClose2() {
            this.diaAddReturn = false;
            this.$refs['formRef2'].resetFields();
        },
        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.ahaId = row.ahaId
                    console.log(jsonObj);
                    updateAjHostelApplyDateCheckOut(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item[key]), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {

            const rowKey = row[key];

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {

            this.formDatas.pageSize = pageSize;
            this.partserch();


        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getAjHostelApplyList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getAjHostelApplyList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        getList() {
            getAjHostelApplyList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>